import map from 'lodash/map';
import sortBy from 'lodash/sortBy';

export function sortDownDistance(filters) {
  return filters.sort((a, b) => {
    if (typeof b !== 'object' || b === null) {
      return b;
    }

    if (b.operand2Max === 'max' || a.operand2Max === 'max') {
      return a.operand1Value - b.operand1Value || a.operand2Min - b.operand2Min;
    }

    return a.operand1Value - b.operand1Value || a.operand2Max - b.operand2Max;
  });
}

export function sortFieldZone(filters) {
  return filters.sort((a, b) => {
    const valA = Number.parseInt(a.operand1Max);
    const valB = Number.parseInt(b.operand1Max);

    if (valB < valA) {
      return -1;
    }

    if (valB > valA) {
      return 1;
    }

    return 0;
  });
}

export function sortGamesList(games) {
  let gameData = [];
  games.forEach((game, i) => {
    /* Expected date string Format MM-DD-YY */
    const parts = game.substring(0, 8).split('-');
    const year = parts[2] < 70 ? `20${parts[2]}` : `19${parts[2]}`;
    const date = new Date(Date.UTC(year, parts[0], parts[1], 0, 0, 0));

    gameData[i] = {
      date,
      game,
    };
  });

  gameData = sortBy(gameData, 'date');
  return map(gameData, 'game');
}

export function sortUserSelections(selections) {
  return selections.sort((a, b) => a.index - b.index);
}
